import React, { useState } from 'react';
import {
  // Redirect,
  Route,
  Switch,
  useRouteMatch,
  withRouter,
} from 'react-router-dom';

// import FormInfo from './forms/formInfo';
// import ListPatientForms from './forms/listPatientForms';
import UseApp from './useApp';
import NoMatch from './noMatch';

// import { changeLang, getLang } from '../../languages/i18n';

function Patient() {
  const { path } = useRouteMatch();

  // const [language, setLanguage] = useState(getLang());

  /* const changeLanguage = (lang) => {
    setLanguage(lang);
    changeLang(lang);
  }; */

  return (
    <Switch>
      {/* Component que carregam per defecte, necessita tenir exact */}
      {/* ATENCIÓ: ListPatientForms, més avall, també té associada la ruta ${path}/listPatientForms */}
      {/*
      <Route exact path={path}>
        <ListPatientForms />
      </Route>
      */}
      {/* ************************ ATENCIÓ: ************************ */}
      {/* De moment hem decidit que un pacient només pot accedir als formularis a través de l'app, si fa login li mostram una pantalla infornant-lo */}
      <Route path={`${path}/listPatientForms`}>
        <UseApp />
      </Route>
      {/* +++++++++++++++++++++++++++++++++++++++++++++++ FORMULARIS +++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* <Route path={`${path}/listPatientForms`}>
        <ListPatientForms lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      <Route path={`${path}/formInfo/:programId/:userScheduleId`}>
        <FormInfo lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route> */}
      {/* NO MATCH */}
      <Route path='*'>
        <NoMatch />
        {/* <Redirect to='/' /> // Alternativa a NoMatch, en lloc de mostrar NoMatch va directa a la pantalla d'inici */}
      </Route>
    </Switch>
  );
}

export default withRouter(Patient);
